const NOTE_NAMES = ['C', 'C♯', 'D', 'E♭', 'E', 'F', 'F♯', 'G', 'A♭', 'A', 'B♭', 'B']

/** MIDI 60 = C4 (middle C). */
export function midiToNoteName(midi: number): string {
  const octave = Math.floor(midi / 12) - 1
  return `${NOTE_NAMES[((midi % 12) + 12) % 12]}${octave}`
}

/** "G3–E5" style range label. */
export function rangeLabel(lowMidi: number, highMidi: number): string {
  return `${midiToNoteName(lowMidi)}–${midiToNoteName(highMidi)}`
}

/** All MIDI values selectable in the Studio range pickers (C2–C7). */
export const MIDI_CHOICES: { midi: number; label: string }[] = Array.from(
  { length: 61 },
  (_, i) => {
    const midi = 36 + i
    return { midi, label: midiToNoteName(midi) }
  }
)
